module.exports = __webpack_public_path__ + "img/intelligence2.a3ea5941.png";